import { LitElement } from 'lit';

type Constructor<T = {}> = new (...args: any[]) => T;

/** Interface describing the public surface added by FormAssociatedMixin. */
export declare class FormAssociatedInterface {
  readonly _internals: ElementInternals;
  get validity(): ValidityState;
  get validationMessage(): string;
  get willValidate(): boolean;
  get form(): HTMLFormElement | null;
  checkValidity(): boolean;
  reportValidity(): boolean;
  setCustomValidity(message: string): void;
}

export const FormAssociatedMixin = <T extends Constructor<LitElement>>(
  Base: T,
): T & Constructor<FormAssociatedInterface> => {
  class FormAssociated extends Base {
    static readonly formAssociated = true;

    readonly _internals: ElementInternals = this.attachInternals();

    get validity(): ValidityState {
      return this._internals.validity;
    }

    get validationMessage(): string {
      return this._internals.validationMessage;
    }

    get willValidate(): boolean {
      return this._internals.willValidate;
    }

    get form(): HTMLFormElement | null {
      return this._internals.form;
    }

    checkValidity(): boolean {
      return this._internals.checkValidity();
    }

    reportValidity(): boolean {
      return this._internals.reportValidity();
    }

    setCustomValidity(message: string): void {
      if (message) {
        this._internals.setValidity({ customError: true }, message);
      } else {
        this._internals.setValidity({});
      }
    }
  }

  return FormAssociated as unknown as T & Constructor<FormAssociatedInterface>;
};
